export const APP_ID = '062097f1b1f34e11e7f82aag22000aee';
export const MEMBER_APP_ID = '86a6b258-ac30-4816-bc14-a31e514226d7';
export const APP_VERSION = '1.0.0';

/** 1 year (unit: day) */
export const TRACKING_COOKIE_AGE__CLIENT_AGE = 365;

/** 30 minutes (unit: day) */
export const TRACKING_COOKIE_AGE__SESSION_AGE = 1 / 48;

/** 60 days(unit: day) */
export const TRACKING_COOKIE_AGE__CHOCOMEMBER_ID_AGE = 60;

export const TRACKING_API_NAME__LOG_TRACKING = 'log_tracking';
export const TRACKING_LOG_VERSION = '1.0.29';

export const TRACKING_OPERATION__SYSCTL = 'sysctl';
export const TRACKING_OPERATION__CLICK = 'click';

export const TRACKING_EVENT__INIT_SESSION = 'init_session';
export const TRACKING_EVENT__PAGE_VIEW = 'pageview';
